export const HOMEPAGE_HIGHLIGHTS_BANNER = {
  title: 'Duck Deep into Transactions',
  description: 'Explore and track all blockchain transactions',
};
